import { useMemo } from "react";
import styles from "./Component1.module.css";

const Component1 = ({
  contentText,
  component1Height,
  quisLoremConsequatContainTextAlign,
}) => {
  const component1Style = useMemo(() => {
    return {
      height: component1Height,
    };
  }, [component1Height]);

  const quisLoremConsequatContainerStyle = useMemo(() => {
    return {
      textAlign: quisLoremConsequatContainTextAlign,
    };
  }, [quisLoremConsequatContainTextAlign]);

  return (
    <div className={styles.component1} style={component1Style}>
      <b className={styles.meetOurTeamContainer}>
        <p className={styles.meetOurTeam}>Meet our Team</p>
      </b>
      <div
        className={styles.quisLoremConsequatContainer}
        style={quisLoremConsequatContainerStyle}
      >
        <p className={styles.meetOurTeam}>
          <b>&nbsp;</b>
        </p>
        <p className={styles.quisLoremConsequat}>{contentText}</p>
      </div>
    </div>
  );
};

export default Component1;
